import {
  FILES,
  FILE,
  DELETE,
  SORT,
  MORE,
  LOADING,
  TOTAL,
  CLEAR_ITEMS,
  RESET_FILTER,
  SET_CLUSTER_OUTFITS,
  RESET_CLUSTERS_ITEMS,
  SET_CLUSTERS,
  SET_CLUSTERS_LOADING,
  RESET_LOGS_ITEMS,
  SET_LOGS,
  SET_LOGS_LOADING,
  SET_POSSIBLE_FPS,
} from './mutation-types';

export default {
  [FILES](state, payload) {
    if (state.items.length > 0) {
      let files = [...state.items];
      if (!!state.sort.filter) {
        files = files.filter((item) => item.name.indexOf(state.sort.filter) !== -1);
      }
      const filesIds = files.map(file => file.id);
      payload.forEach((file) => {
        const index = filesIds.indexOf(file.id);
        if (index > -1) {
          files[index] = file;
        } else {
          files.push(file);
        }
      });
      state.items = files;
    } else {
      state.items = payload;
    }
  },
  [FILE](state, payload) {
    state.items = state.items.map(file => (file.id === payload.id ? Object.assign({}, file, payload) : file));
  },
  [DELETE](state, payload) {
    if (Array.isArray(payload)) {
      state.items = state.items.filter(file => payload.indexOf(file.id) === -1);
    } else {
      state.items = state.items.filter(file => file.id !== payload);
    }
  },
  [SORT](state, payload) {
    state.sort = payload;
  },
  [MORE](state, payload) {
    state.more = payload;
  },
  [LOADING](state, payload) {
    state.loading = payload;
  },
  [TOTAL](state, payload) {
    state.total = payload;
  },
  [CLEAR_ITEMS](state) {
    state.items = [];
    state.total = 0;
    state.more = true;
  },
  [RESET_FILTER](state) {
    state.sort.filter = '';
  },
  [RESET_CLUSTERS_ITEMS](state) {
    state.cluster = {
      ...state.cluster,
      id: null,
      items: {},
      page: 1,
    };
  },
  [SET_CLUSTER_OUTFITS](state, payload) {
    state.cluster.outfits = payload;
  },
  [SET_CLUSTERS](state, payload) {
    state.cluster = payload;
  },
  [SET_CLUSTERS_LOADING](state, payload) {
    state.cluster.loading = payload;
  },
  [RESET_LOGS_ITEMS](state) {
    state.logs.items = [];
  },
  [SET_LOGS](state, payload) {
    state.logs = payload;
  },
  [SET_LOGS_LOADING](state, payload) {
    state.logs.loading = payload;
  },
  [SET_POSSIBLE_FPS](state, payload) {
    state.fps = payload;
  },
};
